<template>
  <div class="d-flex flex-column justify-content-center align-items-center col-md-12 router-view-report-background">
    <div class="col-md-12 px-0">
      <report-filters 
        :partners="partners"
        :creators="creators"
        :status="computedStatus"
        :user="user"
        @get-report="submitReport"  
      />
      <div class="stat-cards">
        <presentation :total_services="computedTotalServices"/>
      </div>
    </div>

    <div class="col-md-12 px-0">
      <the-table 
        id="service-report"
        :dataItems="computedServices"
        :headers="headersForTable"
      >
        <template v-slot:animalsAmount="">
          <span>Qtde Animais</span>
        </template>
        <template v-slot:animals_length="{item}">
          <a class="text-link" @click="showAnimals(item)">{{item.animals.length}}</a>
        </template>

        <template v-slot:hStatus="">
          <span>Status</span>
        </template>
        <template v-slot:status="{item}">
          <div style="display:flex; justify-content:center;">
          <small class="status_info" :style="`color: white; padding: 5px 10px; border-radius: 10px; background-color:${returnColorForStatus(item.status)}`">{{item.status}}</small>
          </div>
        </template>

      </the-table>
    </div>

    <modal-animals 
      :active="animalsModal"
      :service="serviceModal"
      @close="animalsModal = false"
    />

    <button-export
      :print="true"
      @print="PDFPrint"
      v-if="services_report.services && services_report.services.length"
      :excel="true"
      :headers="excel_fields"
      :data="computedExcel"
      :title="'Relatório de Serviços de Pesagem'"
      @export-pdf="PDFExport"
    />
  </div>
</template>

<script>
import Presentation from "./Presentation";
import ReportFilters from "./ReportFilters";
import TheTable from "@/components/layout/TheTable";
import ModalAnimals from "./ModalAnimals";
import ButtonExport from "@/components/layout/ButtonExport";
import {mapState, mapActions} from "vuex";

import { exportOfficialTablePdf } from "@/utils/officialPdf";
export default {
  name:"ServiceReport",
  components: {
    Presentation,
    ReportFilters,
    TheTable,
    ModalAnimals,
    ButtonExport
  },
  data() {
    return {
      headersForTable:[
        {text:"Nº Serviço", value:"code", sortable:true},
        {text:"Status", value:"status", has_slot:true, header_slot:"hStatus", sortable:true},
        {text:"Data do Serviço", value:"created_at", sortable:true},
        {text:"Data do Controle", value:"date", sortable:true},
        {text:"Criador", value:"creator", sortable:true},
        {text:"Controlador", value:"partner", sortable:true},/* 
        {text:"Qtde Animais", value:"animals_length", has_slot:true, header_slot:"animalsAmount", sortable:true},
        {text:"Qtde Mensurados", value:"animals_mensures_count", sortable:true},
        {text:"Qtde Encerrados", value:"animals_closed_count", sortable:true},
        {text:"Qtde PI", value:"animals_pi_count_length", sortable:true}, */
      ],
      animalsModal:false,
      serviceModal:{},
      excel_fields:{
       "Total Serviços":"total_services",
        "Número":"code",
        "Data do Serviço":"date",
        "Criador":"creator",
        "Controlador":"partner",
        "Qtde Animais":"animals_length",
        "Qtde Mensurados":"animals_mensures_count",
        "Qtde Encerrados":"animals_closed_count",
        "Qtde PI":"animals_pi_count_length"
      },
      filters:{}
    }
  },
  computed: {
    ...mapState("services_report", ["services_report"]),
    ...mapState("partners", ["partners"]),
    ...mapState("creators", ["creators"]),
    ...mapState("login", ["user"]),
    //Mapeamento de status
    computedStatus() {
      const result = this.computedServices.filter((set => f => !set.has(f.status) && set.add(f.status))(new Set));
      return result.map(e => {return ({title:e.status, id:this.returnId(e.status)})});
    },
    computedTotalServices() {
      return this.services_report.total_services
    },
    computedServices() {
      if(this.services_report.services) {
        return this.services_report.services.map(e => ({
          ...e, 
          animals_length:e.animals.length, 
          animals_pi_count_length:e.animals_pi_count.length,
          creator:e.creator?.name,
          partner:e.partner?.name
          }));
      }
      else {
        return [];
      }
    },
    computedExcel() {
      if(this.services_report.services) {
        return this.services_report.services.map(e => ({
          ...e, 
          total_services:this.services_report.total_services,
          animals_length:e.animals.length, 
          animals_pi_count_length:e.animals_pi_count.length,
          creator:e.creator?.name,
          partner:e.partner?.name
          }));
      }
      else {
        return [];
      }
    },
  },
  methods: {
    ...mapActions("services_report", ["actionGetServiceReport"]),
    ...mapActions("partners", ["actionGetPartners"]),
    ...mapActions("creators", ["actionGetCreators"]),
    returnId(status) {
      let result = null;
      switch(status) {
        case "Pendente":
          result = "pending"
          break;
        case "Fechado":
          result = "close";
          break;
        case "Em preenchimento":
          result = "open";
          break;
        case "Parcialmente Aprovado":
          result = "unaproved";
          break;
        case "Classificado":
          result = "classified";
          break;
        case "Validado":
          result = "validated";
          break;
          default:
            result = "";
      }
      return result;
    },
    async submitReport(filter) {
      this.filters = filter;
      await this.actionGetServiceReport(filter);
    },
    showAnimals(service) {
      this.serviceModal = service;
      this.animalsModal = true;
    },
    returnColorForStatus(status) {
      if(status === "Em preenchimento") {
        return "#56707a" //dark grey
      }
      if(status === "Pendente") {
        return "#1f6fd1" // azul
      } 
      if(status === "Fechado") {
        return "#127a5c" // verde-azulado
      }      
      if(status === "Validado") {
        return "#2e7d32" // verde
      }
      if(status === "Classificado") {
        return "#9044eb" // purple (mesma cor da lista de Serviços)
      }
      else {
        return "#b45f06" // laranja - Finalizado
      }
    },
    async PDFExport(print = false) {
      const { date, date_end } = this.filters;
      return exportOfficialTablePdf({
        table: "#service-report", title: "RELATÓRIO DE SERVIÇOS DE PESAGEM",
        details: [`Período: ${date || "-"} até ${date_end || "-"}`, `Total de serviços: ${this.computedTotalServices || 0}`],
        filename: `relatorio_servicos_pesagem_${Date.now()}.pdf`, print
      });
    },
    async PDFPrint() {
      await this.PDFExport(true);
    },
  },
  async mounted() {
    await this.actionGetPartners();
    await this.actionGetCreators();
  }
}
</script>

<style>

</style>
